import { Viewport } from "react-flow-renderer";
import { atomFamily } from "recoil";

export const gridViewPortState = atomFamily<Viewport | undefined, string>({
  key: "gridViewPortState",
  default: undefined,
});
